import _ from 'lodash';

import { WorkCenter } from 'models/workcenters';
import { Company } from 'models/companies';
import { SHIFT, TimePeriod } from 'models/baselines';
import { CompanyCollection } from '../Baselines.types';
import { getBaselineTotal } from '../Baselines.helpers';

export const updateIsExpanded = (
  state: TimePeriod[],
  index: number,
  isExpanded: boolean
) => {
  const period = state.slice(index)[0];
  state.splice(index, 1, { ...period, isExpanded });
};

export const checkRequestedDatesAreNotEmpty = (
  requestedState: TimePeriod[]
) => {
  return requestedState !== null && requestedState.length > 0
    ? requestedState.some((request) => request.to === '')
    : true;
};

export const checkRequestedAreNotEqualToApproved = (
  requestedState: TimePeriod[],
  approvedState: TimePeriod[]
) => {
  // clone requested state to be able to compare arrays without isExpanded flag
  const requested = _.cloneDeep(requestedState);
  requested.forEach((line) => _.set(line, 'isExpanded', false));
  return JSON.stringify(requested) === JSON.stringify(approvedState);
};

export const getTimePeriodTotals = (timePeriod: TimePeriod[]) => {
  return timePeriod.map((period) => {
    return {
      ...period,
      totalDay: getBaselineTotal(period.baselines, SHIFT.DAY),
      totalNight: getBaselineTotal(period.baselines, SHIFT.NIGHT),
      isExpanded: false
    };
  });
};

export const getWorkCenterById = (
  workCenters: WorkCenter[],
  workCenter: string
) => {
  return workCenters.filter((wc) => wc.workCenter === workCenter)[0].id;
};

export const getTimePeriod = (
  requestedState: TimePeriod[],
  periodIndex: number
) => {
  return _.get(requestedState, periodIndex);
};

export const getAssociatedCompanies = (
  workCenters: WorkCenter[],
  workCenter: string
) => {
  return _.chain(workCenters)
    .filter((item) => item.workCenter === workCenter)
    .map((wc) => wc.companies)
    .flatten()
    .value();
};

export const getCompanyDropdownList = (
  companies: Company[],
  workCenters: WorkCenter[],
  workCenter: string
): CompanyCollection[] => {
  const nonAssociatedCompanies = _.clone(companies);
  const associatedCompanies = getAssociatedCompanies(workCenters, workCenter);
  associatedCompanies.forEach((associatedCompany) => {
    const associatedCompanyIndex = nonAssociatedCompanies.findIndex(
      (item) => associatedCompany.toLowerCase() === item.id.toLowerCase()
    );
    if (associatedCompanyIndex > -1) {
      nonAssociatedCompanies.splice(associatedCompanyIndex, 1);
    }
  });

  const companyDropdownList = nonAssociatedCompanies.map((item) => {
    return {
      label: item.name,
      value: item.id
    };
  });
  return companyDropdownList;
};
